<script setup lang="ts">
import { ElSlider } from 'element-plus'

/**
 * A value dragged along a bounded scale. It is worth reaching for only when the bounds
 * are part of the answer — an offset that may not exceed 200px, a size read against the
 * screen — because a scale says how much room is left, which a number field cannot.
 */
defineProps<{
  modelValue?: number | null
  min?: number
  max?: number
  step?: number
  disabled?: boolean
  /** Labels pinned under the scale, keyed by the value they sit at. */
  marks?: Record<number, string>
  size?: 'small' | 'default' | 'large'
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: number | null): void
}>()
</script>

<template>
  <ElSlider
    :model-value="modelValue ?? 0"
    :min="min"
    :max="max"
    :step="step"
    :disabled="disabled"
    :marks="marks"
    :size="size"
    @update:model-value="emit('update:modelValue', ($event as number) ?? null)"
  />
</template>
